import { useQuery } from "react-query";
import { api } from "utils/api";
import { SocialMetaData } from "../types";

const DefaultMetaData: SocialMetaData = {
  url: "*",
  pageTitle: "HUG | Community for digital artists and art lovers",
  socialTitle: "HUG | Connecting digital artists and art lovers",
  pageDescription:
    "HUG is a community for artists and art lovers. Discover artists, access education, and earn rewards for leaving reviews.",
  socialDescription:
    "Discover new artists, and access innovative creator-friendly education. Earn rewards for celebrating and curating your favorite artists!",
  socialImage: "https://thehug.xyz/assets/sitepreview-thehugxyz.jpg",
  socialImageAltText:
    "Discover artists on HUG written above a browser window displaying eight different categories of art.",
};

const getSocialMetaData = () => api.get<SocialMetaData[]>(`/system/metadata`);

const useSocialMetaData = () =>
  useQuery(["system", "social-meta-data"], getSocialMetaData);

const useSocialMetaDataForRoute = (url: string) => {
  const { data } = useSocialMetaData();
  try {
    const path = new URL(url).pathname;
    return data?.find((row) => row.url === path) || DefaultMetaData;
  } catch (e) {
    // Prevent runtime error if we can't parse pathname of provided url string
    if (e instanceof TypeError && e.message === "Invalid URL") {
      return DefaultMetaData;
    }
    throw e;
  }
};

export { useSocialMetaDataForRoute };
